import { useAvatarA11yInfo } from '../../Avatar/__internal__/useAvatarA11yInfo';
import { useImageSelectorA11yInfo } from '../../ImageSelector/__internal__/useImageSelectorA11yInfo';
export const useAvatarSelectorA11yInfo = props => {
  const getImageSelectorA11yInfo = useImageSelectorA11yInfo();
  const {
    ariaLabel: imageSelectorAriaLabel,
    tooltip: imageSelectorTooltip
  } = getImageSelectorA11yInfo({
    ariaLabel: props.imageSelectorProps?.ariaLabel,
    tooltip: props.imageSelectorProps?.tooltip
  });
  const {
    ariaLabel: avatarAriaLabel = '',
    tooltip: avatarTooltip = '',
    name: avatarName
  } = useAvatarA11yInfo({
    type: props.type,
    userId: props.userId,
    useAsButton: true,
    dataProvider: props.dataProvider
  });
  return {
    ariaLabel: props.ariaLabel ?? (avatarName === undefined // When avatar is still loading, do not append imageSelectorAriaLabel
    ? avatarAriaLabel ?? '' : [avatarAriaLabel, imageSelectorAriaLabel].join(', ')),
    tooltip: props.tooltip ?? (avatarName === undefined // When avatar is still loading, do not append imageSelectorTooltip
    ? avatarTooltip ?? '' : [avatarTooltip, imageSelectorTooltip].join(', '))
  };
};
//# sourceMappingURL=useAvatarSelectorA11yInfo.js.map